'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = address;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    list: []
};

function address() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _constants.AddressConstants.ADDRESSES_LOAD_SUCCESS:
            {
                return (0, _extends3.default)({}, state, {
                    list: action.result
                });
            }
        case _constants.AddressConstants.ADDRESS_ADD_SUCCESS:
            {
                return (0, _extends3.default)({}, state, {
                    list: [action.result].concat((0, _toConsumableArray3.default)(state.list))
                });
            }
        case _constants.AddressConstants.ADDRESS_UPDATE_SUCCESS:
            {
                var newList = [].concat((0, _toConsumableArray3.default)(state.list));
                var idx = newList.findIndex(function (address) {
                    return address.id === action.payload.id;
                });
                newList[idx].address = action.payload.address;
                newList[idx].is_default = action.payload.is_default;
                if (newList[idx].is_default) {
                    var prevDefaultItemIdx = newList.findIndex(function (address) {
                        return address.is_default && address.id !== action.payload.id;
                    });
                    if (prevDefaultItemIdx >= 0) newList[prevDefaultItemIdx].is_default = false;
                }
                return (0, _extends3.default)({}, state, {
                    list: newList
                });
            }
        case _constants.AddressConstants.ADDRESS_DELETE_SUCCESS:
            {
                var _newList = [].concat((0, _toConsumableArray3.default)(state.list));
                var _idx = _newList.findIndex(function (address) {
                    return address.id === action.payload;
                });
                _newList.splice(_idx, 1);
                return (0, _extends3.default)({}, state, { list: _newList });
            }
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/address.js
// module id = 1894
// module chunks = 0